import { connect } from 'react-redux';

const mapStateToProps = (store) => {
  const { trackerLocationsEvent } = store.TrackerData;
  return {
    mapPosition: trackerLocationsEvent.mapPosition,
  };
};
export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
